import React from "react";
import {styled} from '@mui/material/styles';
import type {StepIconProps} from "@mui/material";
import {Step, StepConnector, StepLabel, Stepper, Typography} from "@mui/material";
import {useStores} from "../../stores";
import {Check} from "@mui/icons-material";
import PropTypes from "prop-types";
import clsx from 'clsx';
import {theme} from "../../style/theme";
import {observer} from "mobx-react-lite";

const PREFIX = 'CategorizationStepper';

const classes = {
    alternativeLabel: `${PREFIX}-alternativeLabel`,
    active: `${PREFIX}-active`,
    completed: `${PREFIX}-completed`,
    line: `${PREFIX}-line`,
    root: `${PREFIX}-root`,
    circle: `${PREFIX}-circle`,
    inactive_circle: `${PREFIX}-inactive_circle`,
    check: `${PREFIX}-check`
};

const _blue = (theme.palette?.primary as any).main || 'purple';
const SIZE = 20;
const CHECKBOX_MARGIN = 2;

const StyledMithraStepIcon = styled('div')({
    [`& .${classes.root}`]: {
        color: 'gray',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    [`& .${classes.active}`]: {
        color: _blue,
    },
    [`& .${classes.completed}`]: {
        color: _blue,
    },
    [`& .${classes.circle}`]: {
        width: SIZE,
        height: SIZE,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    [`& .${classes.inactive_circle}`]: {
        border: 'solid 1px',
        backgroundColor: 'white',
    },
    [`& .${classes.check}`]: {
        color: 'white',
        zIndex: 1,
        width: SIZE - CHECKBOX_MARGIN * 2,
        height: SIZE - CHECKBOX_MARGIN * 2,
        marginLeft: `${CHECKBOX_MARGIN}px`,
        marginTop: `${CHECKBOX_MARGIN}px`,
    },
});
const MithraStepIcon = (props: StepIconProps) => {
    const {active, completed} = props;
    return <StyledMithraStepIcon
        className={clsx(classes.root, {
            [classes.active]: active,
            [classes.completed]: completed,
        })}
    >
        <div className={clsx(classes.circle, {
            [classes.inactive_circle]: !active && !completed,
        })}>
            {completed && <Check className={classes.check}/>}
        </div>
    </StyledMithraStepIcon>
}
MithraStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};


const StyledStepper = styled(Stepper)({
    [`& .${classes.root}`]: {
        color: 'gray',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    [`& .${classes.active}`]: {
        color: _blue,
    },
    [`& .${classes.completed}`]: {
        color: _blue,
    },
    [`& .${classes.circle}`]: {
        width: SIZE,
        height: SIZE,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    [`& .${classes.inactive_circle}`]: {
        border: 'solid 1px',
        backgroundColor: 'white',
    },
    [`& .${classes.check}`]: {
        color: 'white',
        zIndex: 1,
        width: SIZE - CHECKBOX_MARGIN * 2,
        height: SIZE - CHECKBOX_MARGIN * 2,
        marginLeft: `${CHECKBOX_MARGIN}px`,
        marginTop: `${CHECKBOX_MARGIN}px`,
    },
});

const StyledMithraConnector = styled(StepConnector)({
    // TODO: This must be simplified
    [`&`]: {
        top: SIZE / 2,
        left: `calc(-50% + ${SIZE / 2}px)`,
        right: `calc(50% + ${SIZE / 2}px)`,
    },
})

export const TaxonomySuggesterStepper: React.FC = observer(() => {
    const {taxonomySuggesterStoreV2} = useStores();
    // const businessCaseGeneratorStore = businessCaseGeneratorStore.pageController.pageStateController;
    const steps = taxonomySuggesterStoreV2.steps;
    const activeStep = taxonomySuggesterStoreV2.activeStep;

    if (!steps) return <>no steps</>;

    return <StyledStepper
        className="business-case-generator-stepper"
        orientation="horizontal"
        alternativeLabel
        activeStep={activeStep}
        connector={<StyledMithraConnector/>}>
        {steps.map((step, i) =>
            <Step key={i}>
                <StepLabel StepIconComponent={MithraStepIcon}>
                    <Typography variant="caption">
                        {showStep(step)}
                    </Typography>
                </StepLabel>
            </Step>
        )}
    </StyledStepper>
});

function showStep(step) {
    switch (step) {
        case 'select':
            return 'Select Taxonomies and Configure';
        case 'process':
            return 'Processing';
        case 'show':
            return 'Review and Validate';
        default:
            return step;
    }
}
